KXL.module('CookieNoticeApp.CookieNotice', function(CookieNotice, KXL, Backbone, Marionette, $, _) {
	CookieNotice.View = Marionette.Layout.extend({
		template: Templates['cookie_notice/cookie-notice'],
		className: 'kx-cookie-notice',
		triggers: {
			'click .cookie-notice-close':  'cookie_notice_close:clicked',
		}
	});
});
